'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var transform = function transform(_ref) {
    var response = _ref.catalogs,
        count = _ref.count;

    var catalogs = response.map(function (catalog) {
        var items = catalog.results.map(function (item) {
            return {
                hammerPrice: item.hammer_price,
                hammerPriceAtomic: item.hammer_price_atomic,
                itemId: item.lot_id,
                lotNumber: item.lot_num,
                title: item.title
            };
        });

        var transformedCatalog = {
            catalogId: catalog.catalog_id,
            currency: catalog.currency_type.code,
            items: items,
            liveAuctioneersPayments: !!catalog.la_payment,
            saleStartTs: catalog.sale_start_ts,
            sellerId: catalog.house_id,
            sellerName: catalog.house_name,
            title: catalog.auct_title
        };

        if (catalog.invoice) {
            transformedCatalog.invoice = {
                balanceDue: catalog.invoice.balance_due,
                hammerPrice: catalog.invoice.hammer_price,
                paidStatus: catalog.invoice.paid_status,
                sent: !!catalog.invoice.is_sent
            };
        }

        return transformedCatalog;
    });

    return {
        data: {
            catalogs: catalogs,
            count: Number(count)
        },
        message: 'Successfully retrieved the items.',
        success: true
    };
};

exports.default = transform;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/wonLostCatalogsTransform.js
// module id = wTTR
// module chunks = 57